"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;
var _mui = require("@ori-ui/mui");
var _Localization = require("../Localization");
var _constants = require("../constants");
var _contexts = require("../contexts");
var _models = require("../models");
var _jsxRuntime = require("react/jsx-runtime");
const StyledHeaderWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  width: '100%',
  height: '100%',
  marginBottom: theme.spacing(8),
  textAlign: 'center'
}));
const StyledTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(3)
}));
const Header = () => {
  const {
    loginUrl
  } = (0, _contexts.useConfiguration)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledHeaderWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTitle, {
      variant: "h4",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.General_header,
        id: _models.TranslationKey.General_header
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "body1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _constants.defaultTranslations.General_Already_Registered,
        id: _models.TranslationKey.General_Already_Registered,
        values: {
          LoginLink: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
            color: "textPrimary",
            variant: "body1",
            href: loginUrl,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
              defaultMessage: _constants.defaultTranslations.loginLinkLabel,
              id: _models.TranslationKey.loginLinkLabel
            })
          })
        }
      })
    })]
  });
};
exports.Header = Header;
//# sourceMappingURL=Header.js.map